import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { Manufacturer, ManufacturerCreation, UploadPhotoResult } from 'src/api'
import axios, { AxiosResponseTransformer } from 'axios'
import { ValuesToResize } from 'src/config'
import { useApiInstance } from './useApiInstance'
import { useSignInRedirect } from '../ui'

interface RequestParams {
  options?: Omit<UseMutationOptions<Manufacturer, Error, RequestUpload>, 'mutationKey' | 'mutationFn'>
}

interface RequestUpload extends ManufacturerCreation {
  photos?: Array<any> | null
}

export const useNewManufacturerRequest = ({
  options,
}: RequestParams) => {
  const api = useApiInstance()
  const redirect = useSignInRedirect()

  return useMutation<Manufacturer, Error, RequestUpload>(
    [Entities.Manufacturers, 'create'],
    async (payload: RequestUpload) => {
      const { photos, ...creationPayload } = payload
      if (Array.isArray(photos) && photos.length > 0) {
        let photoResult: Array<UploadPhotoResult> = []
        try {
          await api.v1MediaPhotoPut(photos, ValuesToResize.manufacturer, {
            transformResponse: [
              ...(axios.defaults.transformResponse as AxiosResponseTransformer[]),
              ({ error, result, statusCode }) => {
                if (error) {
                  if (statusCode === 401) redirect()
                  throw new Error(error)
                }
                photoResult = result
              },
            ],
          })
        } catch (e) {
          console.log(e)
        }

        if (photoResult?.length > 0) {
          const uploadedPhoto = photoResult[0].original
          creationPayload.photo = uploadedPhoto
        }

        const { data } = await api.v1AdminManufacturersPost(creationPayload)
        return data as Manufacturer
      }

      const { data } = await api.v1AdminManufacturersPost(creationPayload)
      return data as Manufacturer
    },
    options,
  )
}
